import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { useMemo, useState } from "react";

export function alphaNumericWithSpace(data) {
  try {
    let numvalue = data;
    numvalue = numvalue.replace(/[^A-Za-z0-9\s]/g, '')
    return numvalue;
  }
  catch (error) {
    return error;
  }
}

export function AlphabetAllows(data) {
  try {
    let value = data;
    value = value.replace(/[^A-Za-z]/gi, '')
    return value;
  }
  catch (error) {
    return error;
  }
}

export function onlyAlphabets(data) {
  try {
    let value = data;
    value = value.replace(/[^a-z\s]/gi, '')
    return value;
  }
  catch (error) {
    return error;
  }
}
export function PhoneNmber(num) {
  try {
    let numvalue = num;
    numvalue = numvalue.replace(/[^0-9\+\-\(\)]/, '')
    return numvalue;
  }
  catch (error) {
    return error;
  }
}

export function onlyNumeric(numdata) {
  try {
    let numvalue = numdata;
    numvalue = numvalue.replace(/[^0-9]/g, ''); // Added 'g' flag for replacing all non-digits
    return numvalue;
  } catch (error) {
    return error;
  }
}

export function alphaNumeric(data) {
  try {
    let numvalue = data;
    numvalue = numvalue.replace(/[^A-Za-z0-9]/g, '')
    return numvalue;
  } catch (error) {
    return error;
  }
}

export function alphaNumericspace(data) {
  try {
    let numvalue = data;
    numvalue = numvalue.replace(/[^A-Za-z0-9\s]/g, '')
    return numvalue;
  }
  catch (error) {
    return error;
  }
}
export function normalizeInput(value, previousValue) {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  }
};
export function NumericWithDecimal(num) {
  try {
    let numvalue = num;
    numvalue = numvalue.replace(/[^0-9\.]/, '')
    return numvalue;
  }
  catch (error) {
    return error;
  }
}
export function isValidEmail(email) {
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(email);
}

export function isValidPhonenumber(num) {
  return /^[\d\(\)\-+]+$/m.test(num);
}
export function validateURL(URL) {
  return /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm.test(URL)

}
export function useSortableData(items, config = null) {
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {
    let sortableItems = [...items];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key, dir) => {

    let direction = dir;
    //   if (
    //         sortConfig &&
    //         sortConfig.key === key &&
    //         sortConfig.direction === 'ascending'
    //      ) 
    //   {
    //         direction = 'descending';
    //   }
    setSortConfig({ key, direction });
  };
  //setDestinationListData(sortedItems)
  return { items: sortedItems, requestSort, sortConfig };
}

export function generatePDF(columns, rows, filename, filetitle, orientationtype = "p") {
  const pdf = new jsPDF(orientationtype, "pt", "a4");
  let textX = (pdf.internal.pageSize.getWidth() - pdf.getTextWidth(filetitle)) / 2

  pdf.text(filetitle, textX, 40);
  pdf.autoTable(columns, rows, {
    startY: 65,
    theme: "grid",
    styles: {
      font: "times",
      minCellWidth: 33,
      cellPadding: 3.5,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0]
    },
    headStyles: {
      textColor: [0, 0, 0],
      halign: "center",
      fontStyle: "bold",
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      fillColor: [166, 204, 247]
    },
    alternateRowStyles: {
      fillColor: [212, 212, 212],
      textColor: [0, 0, 0],
      lineWidth: 0.5,
      lineColor: [0, 0, 0]
    },
    rowStyles: {
      lineWidth: 0.5,
      lineColor: [0, 0, 0]
    },
    tableLineColor: [0, 0, 0]
  });
  pdf.save(filename);
}
export function isValidImage(FileName) {
  return /\.(png|jpeg|jpg|gif)$/i.test(FileName)
}
export function isValidVideo(DocName) {
  return /\.(mov|mp4|mp3|wmv|avi)$/i.test(DocName)
}
export function isNoSpecialCharacter(strvalue) {
  return /^[A-Za-z0-9 ]+$/.test(strvalue)
}
export function isNotaNumber(str) {
  return /[^\d]/.test(str)
}
export function passWord(data) {
  try {
    let numvalue = data;
    numvalue = numvalue.replace(
      /[^A-Za-z0-9!@#$%^&(){}[:;<>,.?~_+-=\\/|]/g,
      ""
    );
    return numvalue;
  } catch (error) {
    return error;
  }
}

export const CheckPassword = (password) => {
  const passRegex = new RegExp(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).+$/g);
  return passRegex.test(password);
}

export function isValidBankAccountNumber(data) {
  const regEx = new RegExp(/^[0-9]{9,18}$/g);
  return regEx.test(data);
}

export function isValidIFSCCode(data) {
  const regEx = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);
  return regEx.test(data);
}
export const isValidGST = (data) => {
  const regEx = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
  return regEx.test(data);
}

export function isValidPAN(data) {
  const regEx = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)
  return regEx.test(data);
}

export function isValidTAN(data) {
  const regEx = new RegExp(/^[A-Z]{4}[0-9]{5}[A-Z]{1}$/);
  return regEx.test(data);
}

export function Debounce(func, delay) {
  let timeoutId;
  return (...args) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
export const isBlank = ["", null, undefined];
export const isBlankWithZero = ["", null, undefined, 0];
export const ApiNotRespondMessage = "Something went wrong, Please try again!";
export const imageURLpathCommon = "https://static-ethics.sgp1.digitaloceanspaces.com/etm/";

export const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today?.getFullYear() - birthDate?.getFullYear();
  const monthDiff = today?.getMonth() - birthDate?.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today?.getDate() < birthDate?.getDate())) {
    age--;
  }

  return age;
};

export function ToolTip({ titleData = "", data, ...props }) {
  return (
    <div {...props} className="text-truncate" title={titleData || data} >{data}</div>
  )
}

export const isValidPDFFile = (name) => {
  return /\.(pdf)$/i.test(name);
}

export function checkIsPlainObject(val) {
  return typeof val === "object" && val !== null && !Array.isArray(val);
}

export function checkIsArray(val) {
  return Array.isArray(val);
}

export const HotelResponseTime = 23;

export function numberWithCommas(x) {
  return x?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

export const getPassengerType = (type) => {
  switch (type) {
    case 1: return 'Adult';
    case 2: return 'Child';
    case 3: return 'Infant';
    default: return '';
  }
}

export const MultiCityobject = (input) => {
  const segments = [];
  const numberOfLegs = Object?.keys(input)?.filter(key => key?.startsWith('fcc'))?.length;
  for (let i = 1; i <= numberOfLegs; i++) {
    const fcc = input[`fcc${i}`]; // From city code
    const tcc = input[`tcc${i}`]; // To city code
    const departureCity = input[`departure${i}`];
    const destinationCity = input[`destination${i}`];
    const departureDate = input[`DepartureDate${i}`];
    const segment = {
      FromCityCode: fcc || '',
      ToCityCode: tcc || '',
      JourneyType: 3, // Multi Stop
      adults: input?.adults || 1,
      children: input?.children || 0,
      infants: input?.children || 0,
      Departure: departureDate + 'T00:00:00' || null,
      Return: null,
      FlightCabinClass: input?.class || 2,
      AirportFromLocationName: departureCity || '',
      AirportToLocationName: destinationCity || '',
    };
    segments.push(segment);
  }

  return segments;
}

export function formatDateRequire(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return date ? [day, month, year].join('/') : null;
}

export function formatDateddmmyyy(date, type) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return date === null ? null : [day, month, year]?.join(type);
}

export function formatDateyyyymmdd(date, type) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return date === null ? null : [year, month, day]?.join(type);
}


export function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

export function formatetimeampm(date) {
  var d = new Date(date);
  const options = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  const timeString = d?.toLocaleTimeString('en-US', options);
  return date ? timeString : null;
}

export function formatDatewithtime(dateStr) {
  const date = new Date(dateStr);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert to 12-hour format
  return dateStr === null ? null : `${day}/${month}/${year} & ${hours}:${minutes} ${ampm}`;
}

export function formatDatetimemonth(dateStr) {
  const date = new Date(dateStr);

  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";
  const day = date.getDate();
  const daySuffix =
    day % 10 === 1 && day !== 11 ? "st" :
      day % 10 === 2 && day !== 12 ? "nd" :
        day % 10 === 3 && day !== 13 ? "rd" : "th";

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];

  return dateStr === null ? null : `${hours}:${minutes} ${ampm}, ${day}${daySuffix} ${month} ${date.getFullYear()}`;
}

export function formatJsonDateToSQL(dateInput) {
  const date = new Date(dateInput);

  // Pad with zero if needed
  const pad = (n) => n.toString().padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Month is zero-based
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}


export const formateDateMonthYear = (date) => {
  const d = new Date(date);
  const day = d?.toLocaleString("en-US", { day: 'numeric' });
  const month = d?.toLocaleString("en-US", { month: 'short' });
  const year = d?.toLocaleString("en-US", { year: 'numeric' });
  return date ? `${day}-${month}-${year}` : null;
}

export const dateFormat = (date) => {
  const d = new Date(date);
  const weekday = d?.toLocaleString("en-US", { weekday: 'short' });
  const day = d?.toLocaleString("en-US", { day: 'numeric' });
  const month = d?.toLocaleString("en-US", { month: 'short' });
  const year = d?.toLocaleString("en-US", { year: 'numeric' });
  return date ? `${day} ${month} ${year}, ${weekday}` : null;
}

export function formatTimeHourMinute(time) {
  let x = new Date(time)
  let hours = x.getHours();
  let minut = x.getMinutes();
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minut < 10) {
    minut = '0' + minut
  }
  return time === null ? '' : [hours, minut].join(':');
}

export function dateFromHourMinSec(timeString) {
  const today = new Date();
  const [hours, minutes, seconds] = timeString?.split(":");
  today.setHours(hours, minutes, seconds, 0);
  return today
}

export function formatDateMonthYear(date) {
  let d = new Date(date),
    dayNum = d?.getDate()?.toString(),
    month = d?.toLocaleString("en-US", { month: "short" }),
    year = d?.getFullYear()?.toString()

  return date === null ? null : `${dayNum?.length <= 1 ? '0' + dayNum : dayNum} ${month} ${year}`; // 20 Mar 2025
}

export const calculateDifference = (date1, date2) => {
  const diffInMs = Math.abs(new Date(date2) - new Date(date1)); // Get difference in milliseconds
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60)); // Convert to minutes
  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;

  return `${hours}h ${minutes}m`
};

export function formatDateAndTime(inputDate) {
  const date = new Date(inputDate);

  const optionsTime = { hour: 'numeric', minute: 'numeric', hour12: true };
  const formattedTime = date.toLocaleString('en-US', optionsTime);

  const optionsDate = { weekday: 'short', day: '2-digit', month: 'short' };
  const formattedDate = date.toLocaleString('en-US', optionsDate);

  return { time: formattedTime, date: formattedDate }  // { time: 7:25 PM, date: Sun, Apr 06 }
}